import type { QueryClient } from "@tanstack/react-query";

/**
 * 登录态切换时清空客户端查询缓存。
 * 避免顶栏用户信息与按用户隔离的业务查询在换号后串号。
 */
export function resetAuthSessionQueries(queryClient: QueryClient): void {
  queryClient.clear();
}
